import React from 'react';
import { Text } from '@morressier/ts';
import { ResultsContainer } from './style';
interface IResultsTextProps {
  totalResults: string;
  type?: string;
  searchTerm?: string;
}

export const ResultsText = ({
  totalResults,
  type,
  searchTerm
}: IResultsTextProps) => {
  return (
    <ResultsContainer>
      <Text size="caption_new" color="grey">
        Showing{' '}
        <Text
          size="caption_new"
          color="grey"
          style={{ display: 'inline-block' }}
        >
          {totalResults} {type || 'results'}{' '}
          {searchTerm && `for "${searchTerm}"`}
        </Text>
      </Text>
    </ResultsContainer>
  );
};
